module.exports = __webpack_public_path__ + "img/heart_20.51c5169b.png";